import { reactive } from "vue";
//import { io } from "socket.io-client";

import * as io from 'socket.io-client'

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: []
});

// "undefined" means the URL will be computed from the `window.location` object
//const URL = "https://lrc3s.gvticonsultoria.com.br";
const URL = process.env.MIX_VUE_APP_AUDITORIO;

export const socket = io(URL);

socket.on("connect", () => {
  state.connected = true;
});

socket.on("disconnect", () => {
  state.connected = false;
});

socket.on("bar", (...args) => {
  state.barEvents.push(args);
});